import { Feature } from 'ol';
import { Geometry, LineString } from 'ol/geom';

import { polygon, lineString as turfLine, Feature as TurfFeature } from '@turf/helpers';
import booleanWithin from '@turf/boolean-within';
import booleanCrosses from '@turf/boolean-crosses';

import { CreateDateLineAndGreatCircleFeatures } from '../utils/map-utils';
import { RouteGeometry } from '../models/voyage-routing-model';

export interface CrossedGeometry {
    geometry? : { 
        type: string;
        coordinates: number[] | number[][][] | number[][][][];
        radius?: number; // circle type radius in km
    }
}

export function CrossedGeometries<T extends CrossedGeometry>(routeGeometry: RouteGeometry, geometries: T[]) : T[] {
    const features : Feature<Geometry>[] = [];

    routeGeometry.filter(f => f.geometry.type === "LineString").forEach(f => {
        const lineString = new Feature({
            geometry: new LineString(f.geometry.coordinates)
        });
        
        if (f.properties.leg_type) {
            lineString.setProperties({"leg_type": f.properties.leg_type});
        }

        features.push(...CreateDateLineAndGreatCircleFeatures(lineString));
    })

    const routeLines = features.filter(f => f.getGeometry()?.getType() === "LineString").map(l => turfLine((<LineString>l.getGeometry()).getCoordinates()));
    const crossedGeometries = new Set<T>();

    geometries!.forEach(area => {
        let areaGeometry: TurfFeature<any>[] = [];
        if (area.geometry!.type === "MultiPolygon") {
            (<number[][][][]>area.geometry!.coordinates).forEach(p => areaGeometry.push(polygon(p)));
        }
        if (area.geometry!.type === "Polygon") {
            areaGeometry.push(polygon(<number[][][]>area.geometry!.coordinates));
        }
        
        routeLines.forEach(line => {
            areaGeometry.forEach(p => {
                if (booleanCrosses(line, p)) {
                    crossedGeometries.add(area);
                }

                if (booleanWithin(line, p)) {
                    crossedGeometries.add(area);
                }
            });
        });
    });


    return Array.from(crossedGeometries);
}